// gatsby-browser.js

import './src/styles/global.css';
import "@fontsource/inter/300.css"; // Light
import "@fontsource/inter/400.css"; // Normal
import "@fontsource/inter/500.css"; // Medium
import "@fontsource/inter/600.css"; // Semi-bold
import "@fontsource/inter/700.css"; // Bold
import "@fontsource/montserrat/300.css"; // Light
import "@fontsource/montserrat/400.css"; // Normal
import "@fontsource/montserrat/500.css"; // Medium
import "@fontsource/montserrat/600.css"; // Semi-bold
import "@fontsource/poppins/400.css"; // Regular
import "@fontsource/poppins/600.css"; // Semi-bold

// Opcional: Adicionar suporte para scroll suave
export const onClientEntry = () => {
  // Define o idioma para Português do Brasil
  document.documentElement.lang = "pt-BR";

  // IntersectionObserver polyfill para navegadores mais antigos
  if (typeof window.IntersectionObserver === `undefined`) {
    import(`intersection-observer`);
  }
};

// Opcional: Wrapper para o React Context API
export const wrapRootElement = ({ element }) => {
  return element;
};

// Opcional: Scroll para o topo em mudanças de página
export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const { pathname } = location;

  // Lista de rotas onde queremos manter a posição do scroll
  const scrollToTopRoutes = [`/cases/`];

  if (scrollToTopRoutes.includes(pathname)) {
    window.scrollTo(0, 0);
    return false;
  }

  return true;
};
